/** VIX → implied daily expected move (annualized IV → 1-day). */

const TRADING_DAYS_PER_YEAR = 252;

/**
 * VIX is quoted as annualized implied volatility (%).
 * One standard-deviation daily move ≈ VIX / sqrt(252).
 * Rule-of-thumb: VIX / 16 (~sqrt(256)).
 */
export function vixImpliedDailyMove(vix, spotPrice = null) {
  if (vix == null || !Number.isFinite(vix) || vix <= 0) return null;
  const oneSigmaPct = vix / Math.sqrt(TRADING_DAYS_PER_YEAR);
  const ruleOf16Pct = vix / 16;
  const moveDollars =
    spotPrice != null && Number.isFinite(spotPrice)
      ? (spotPrice * oneSigmaPct) / 100
      : null;
  return {
    vix,
    oneSigmaPct,
    ruleOf16Pct,
    moveDollars,
    /** ±1σ range string for UI */
    label: moveDollars != null
      ? `±$${moveDollars.toFixed(2)} (${oneSigmaPct.toFixed(2)}%)`
      : `±${oneSigmaPct.toFixed(2)}% (1σ day)`,
    tooltip:
      `At VIX ${vix.toFixed(1)}, the market prices about a ${oneSigmaPct.toFixed(2)}% one-day move (1σ) — roughly ${ruleOf16Pct.toFixed(2)}% using the ÷16 shortcut. ` +
      "About 68% of sessions stay inside ±1σ; large trend days can exceed it.",
  };
}
